<template>
    <div class="container" style="height:450px;overflow:hidden;">
        
            <img :src="$root.urlsite+'documenti/backHome.png'" style="margin:0;"/>
       
    </div>
</template>

<script>

export default {
  name: 'site-header',
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// Image-home.vue?69988f80